import MwpCustomerProfileList from './containers/customerList'

export { MwpCustomerProfileList }
